/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraDataCenterMappingBase {
    getFixupPrototypeFunction() { return JiraDataCenterMappingBase.fixupPrototype; }

    static newInstance(model: Partial<JiraDataCenterMappingBase>): JiraDataCenterMappingBase {
        let obj = Object.assign(new JiraDataCenterMappingBase(), model);
        JiraDataCenterMappingBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraDataCenterMappingBase>): JiraDataCenterMappingBase {
        if (!model) return null;
        return JiraDataCenterMappingBase.newInstance(<JiraDataCenterMappingBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraDataCenterMappingBase) {
        if (!obj) return;

        models.JiraDataCenterMappingBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraDataCenterMappingBase): boolean {
        Object.setPrototypeOf(obj, JiraDataCenterMappingBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.project) {
            models.JiraDataCenterProject.fixupPrototype(this.project);
        }
    }

    /**
     * Projects attribute mapping for JIRA DataCenter
     */
    project: models.JiraDataCenterProject;

    /**
     * Priority for JIRA DataCenter Policy
     */
    priority: models.JiraDataCenterPriority;

}
